/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Artifact_Confirm_Creating_DetailInputs */



/**
* | output |
* | --- |
* | "This may take a moment..." |
*
* @param {Chat_Artifact_Confirm_Creating_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifact_confirm_creating_detail = /** @type {((inputs?: Chat_Artifact_Confirm_Creating_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifact_Confirm_Creating_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das kann einen Moment dauern...")
	return /** @type {LocalizedString} */ ("This may take a moment...")
});